import React from 'react'
import {
    Pie,
    PieChart,
    legend
  } from 'recharts';

  const data1 = [
    {
      "name": "Loss Weight",
      "value": 2400,
      fill : "#00E7EF"
    },
    {
      "name": "Gain Weight",
      "value": 4567,
      fill : "#005CFF"
    }
  ];
  const data2 = [
    {
      "name": "Health",
      "value": 3100,
      fill : "#00E7EF"
    },
    {
      "name": "Health",
      "value": 1033,
      fill : "#005CFF"
    }
  ];

  
export default function Piechart() {
  return (
    <div className='piechart_outer'>
      <div className='piechart_inner'>
        <PieChart width={200} height={200}>
          <Pie
            data={data1} 
            dataKey="value"
            nameKey="name" 
            cx="50%" cy="50%" 
            startAngle={360}
            endAngle={0}
            cornerRadius={40}
            innerRadius={60}
            outerRadius={80}
            paddingAngle={-10}
          />            
        </PieChart>
        <h3>
          General health<span>70% Increase</span>
        </h3>
      </div>
        
      <div className='piechart_inner'>
        
        <PieChart width={200} height={200}>
            <Pie
              data={data2} 
              dataKey="value"
              nameKey="name" 
              cx="50%" cy="50%" 
              startAngle={360}
              endAngle={0}
              cornerRadius={40}
              innerRadius={60}
              outerRadius={80}
              paddingAngle={-10}
            />
        </PieChart>
        <h3>
          General health<span>70% Increase</span>
        </h3>
        </div> 
    </div>
  )
}
